import React from 'react';
import clsx from 'clsx';
import InputAdornment from '@material-ui/core/InputAdornment';
import DropdownMechanism from '../../../../../GeneralComponents/DropdownMechanism';
import { checkIfEmpty, checkIfNameExists } from '../../../../../../validations/validations';
import { NameTextField } from '../../../../../../styling/Styles';

const AnnotationEntityRow = ({
  newSelected,
  entity,
  entities,
  entityName,
  annotationName,
  annotationType,
  setNewSelected,
  setEntity,
  setEntityName
}) => {
  // This functions updates the selected entity option and displays the text input if new entity has been selected.
  const selectEntity = (option) => {
    setNewSelected(false);
    setEntity(option);
  };

  // This function handles the text input of the new entity name and stores the given text to var  new entity name.
  const handleNewEntityName = (val) => {
    setEntityName(val.target.value);
  };

  // This function opens the text input to give a new entity link.
  const addNewLink = () => {
    if (newSelected === false) {
      setNewSelected(true);
      setEntityName('');
    }
  };

  const hasError = () => {
    if (checkIfEmpty(entityName) === true) return true;
    if (checkIfNameExists(entityName, entities) === true) return true;
    if (/[A-Z\W\d_]+/.test(entityName)) return true;
    return false;
  };
  const errorText = () => {
    if (checkIfEmpty(entityName) === true) return 'Entity name empty';
    if (checkIfNameExists(entityName, entities) === true) return 'Entity name already exists';
    if (/[A-Z\W\d_]+/.test(entityName)) return 'Only small case letters (a-z)';
    return false;
  };

  return (
    <div className={clsx('spacingTopDiv')}>
      <div className={clsx('flexRowDirection')}>
        <div>
          <span>
            Assign to entity: &nbsp;
            <span style={{ display: 'inline-block', marginLeft: '3.2rem' }} />
          </span>
        </div>
        <div style={{ display: 'flex', flexDirection: 'column' }}>
          <div style={{ display: 'flex' }}>
            {newSelected === false ? (
              <DropdownMechanism target={entity} targets={entities} selectTarget={selectEntity} />
            ) : (
              <NameTextField
                placeholder=" Entity link"
                error={hasError()}
                helperText={errorText()}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end" className={clsx('greyLabel')}>
                      <DropdownMechanism target="" targets={entities} selectTarget={selectEntity} />{' '}
                      &nbsp;
                    </InputAdornment>
                  )
                }}
                onInput={(e) => handleNewEntityName(e)}
                value={entityName}
                className={clsx('greyLabel')}
                style={{ width: '90%' }}
              />
            )}
          </div>
          <span
            className={clsx('MuiFormHelperText-root', 'Mui-error')}
            style={
              newSelected === false &&
              entity === 'none' &&
              (annotationName !== '' || annotationType !== 'none')
                ? { display: 'inherit' }
                : { display: 'none' }
            }
          >
            Entity none
          </span>
        </div>
      </div>

      <div>
        <button
          type="button"
          onClick={() => addNewLink()}
          className={clsx('lightBlue', 'spacingTopDiv', 'teamSelector')}
          style={{ fontSize: '0.9vw', border: 'none', background: 'none' }}
        >
          +Add new entity
        </button>
      </div>
    </div>
  );
};

export default AnnotationEntityRow;
